const userLabel = {
    namespaced: true,
    state: {
        phone: '',
        from: '',   // 流量来源
        token: '', 
        unionId: '',
        memberId: '', 
        showback: false,
        type: '',
    },
    mutations: {
        set_phone: (state, data) => {
            state.phone = data;
        },
        set_from: (state, data) => {
            state.from = data;
        },
        set_token: (state, data) => {
            state.token = data;
        },
        set_unionId: (state, data) => {
            state.unionId = data;
        },
        set_memberId: (state, data) => {
            state.memberId = data;
        },
        set_showback: (state, data) => {
            state.showback = data;
        },
        set_type: (state, data) => {
            state.type = data;
        }
    }
}

export default userLabel;